<template>
    <div class="table-responsive product-create">
        <table class="table table-bordered table-custom mb-0">
            <thead>
            <tr>
                <th style="width: 70px">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="checkAll" name="checkAll"
                               v-model="checkAll"
                               v-on:click="checkAllEvent($event)">
                        <label class="custom-control-label" for="checkAll">All</label>
                    </div>
                </th>
                <th>Item #</th>
                <th>Item name</th>
                <th>Quantity</th>
                <th>UOM</th>
                <th>Cost</th>
                <th>Total</th>
                <th>Vendor</th>
            </tr>
            </thead>
            <template v-if="productData && productData.products">
                <template v-for="(product, index) in productData.products.data">
                    <tr :id="product.id">
                        <td>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input"
                                       :value="product.id"
                                       :id="'id_' +index"
                                       name="prod_ids[]"
                                       :checked="selectedProducts.includes(product.id)"
                                       v-on:click="selectProductCheckbox(product, $event)">
                                <label class="custom-control-label" :for="'id_' +index"></label>
                            </div>
                        </td>
                        <td><input type="text" class="form-control form-custom" placeholder="Item#"
                                   v-model="productData.products.data[index].product_num"/></td>
                        <td>
                            <input v-model="productData.products.data[index].product_name" type="text"
                                   class="form-control form-custom mb-1" placeholder="">

                                   <vue-editor
                                :id="'editor_' + index + '_' + product.id"
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                                v-model="productData.products.data[index].product_desc"
                                :editorToolbar="editorOptions"
                                >
                                </vue-editor>

                            <!-- <ckeditor v-model="productData.products.data[index].product_desc"
                                      type="inline"
                                      :config="editorConfigMin"></ckeditor> -->
                        </td>
                        <td>
                            <ValidationProvider name="Quantity" immediate rules="required|positive|min_value:1"
                                                v-slot="{ errors }">
                                <input type="text" class="form-control form-custom" placeholder=""
                                       v-on:keydown="checkNumber($event)"
                                       v-model="productData.products.data[index].quantity">
                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </td>
                        <td>
                            <ValidationProvider name="Quantity unit" rules="required" v-slot="{ errors }">
                                <select class="form-control" v-model="productData.products.data[index].qty_unit_id">
                                    <option value="">Select</option>
                                    <option v-for="(qtyUnit, unitIndex) in quantityUnits" :value="qtyUnit.id">
                                        {{ qtyUnit.name }}
                                    </option>
                                </select>
                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </td>
                        <td>
                            <ValidationProvider name="Price" rules="required|positive|min_value:0" v-slot="{ errors }">
                                <input type="text" class="form-control form-custom dollar-prefix" placeholder=""
                                       v-on:keydown="checkDecimal($event, this)"
                                       v-model="productData.products.data[index].price">
                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </td>
                        <td>
                            <ValidationProvider name="Cost" rules="required|positive|min_value:0" v-slot="{ errors }">
                                <input readonly type="text" class="form-control form-custom dollar-prefix" placeholder=""
                                       v-on:keydown="checkDecimal($event, this)"
                                       v-model="productData.products.data[index].cost">
                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                            </ValidationProvider>
                        </td>
                        <td>
                            <template v-if="getVendorId(product)">
                                <router-link
                                    :to="{name: 'vendorDetails', params: {id: getVendorId(product)}}"
                                    title="Details vendor" target="_blank">
                                    {{ getVendorName(product) }}</router-link>
                            </template>
                        </td>
                    </tr>
                </template>
            </template>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import { VueEditor } from "vue2-editor";
export default {
    name: "OrderProducts",
    components: {
        ValidationProvider, ValidationObserver,VueEditor
    },
    props: ['selectedProducts', 'search_filter', 'bus', 'quantityUnits', 'orderId'],
    created() {
        this.getProducts();
    },
    mounted() {
        if (this.search_filter) {
            this.filterForm.search_filter = this.search_filter;
        }
        this.bus.$on('getProducts', this.getProducts)
    },
    data() {
        return {
            editorOptions: [],
            productData: {
                orders: {
                    data: []
                },
                config: null,
            },
            current_page: 1,
            per_page: 10,
            total: 0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            },
            checkAll: true,
            editorConfig: {},
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        getVendorName(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.company_name;
            }
            return null;
        },
        getVendorId(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.id;
            }
            return null;
        },
        getVendorFromProduct(product) {
            if (product.default_vendor) {
                return product.default_vendor;
            } else if (product.product && product.product.vendor) {
                return product.product.vendor;
            } else if (product.quote_product && product.quote_product.quotation_prices) {
                let vendor = null;
                product.quote_product.quotation_prices
                    .filter((x) => (x.deleted == '0' || x.deleted == 0) && x.vendor !== null)
                    .forEach((qp) => {
                        if (qp.vendor && vendor == null) {
                            vendor = _.cloneDeep(qp.vendor);
                        }
                    });
                return vendor;
            }
            return null;
        },
        checkAllEvent(event) {
            this.productData.products.data.forEach((x) => {
                this.selectProduct(x, event.target.checked);
            });
        },
        selectProductCheckbox(c, event) {
            this.$emit('selectProduct', {c: c, checked: event.target.checked});
        },
        selectProduct(c, checked) {
            if (checked === null) {
                checked = !this.selectedProducts.includes(c.id);
            }
            this.$emit('selectProduct', {c: c, checked: checked});
        },
        getProducts() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so.orderProducts.search', {
                id: this.orderId,
                page: this.current_page,
                search_filter: this.filterForm.search_filter,
                status_filter: this.filterForm.status_filter
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if(data.data && data.data.products && data.data.products.data) {
                            data.data.products.data.forEach((x) => {
                                if(x.vendor_cost) {
                                    x.price = x.vendor_cost;
                                }
                            })
                        }
                        this.productData = data.data;
                        this.current_page = data.data.products.current_page;
                        this.per_page = data.data.products.per_page;
                        this.total = data.data.products.total;

                        if (this.checkAll == true) {
                            this.productData.products.data.forEach((x) => {
                                this.selectProduct(x, true);
                            });
                        }

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        },
        updateProducts(products) {
            let updatedProducts = products.filter((x) => this.selectedProducts.filter((y) => y == x.id).length > 0);
            this.$emit('watchChangedProducts', updatedProducts);
        },
    },
    watch: {
        "productData.products.data": {
            handler: function (after, before) {
                after.forEach((x, index) => {
                    this.productData.products.data[index].unit_price = this.strAmountToNumber(x.price);
                    let sum = this.strAmountToNumber(x.price) * x.quantity;
                    if (!isNaN(sum)) {
                        this.productData.products.data[index].cost = sum;
                        after[index].cost = sum;
                    }

                });
                this.updateProducts(after);
            },
            deep: true,
        },
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getProducts();
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        selectedProducts: {
            handler: function (value) {
                if (value != null && this.productData.products.data != null &&
                    this.productData.products.data.filter((x) => value.includes(x.id)).length == this.productData.products.data.length) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>
.error {
    color: red;
}
</style>
